<!--  -->
<template>
  <div class="icomposite-page">
    <screen-panel :isExpand="isOpen" class="panel">
      <screen-box title="上月水电用量统计" height="20%">
        <div class="box-content flex-between">
          <div class="content-item" @click="chartClick('100101')">
            <div class="title">上月用电量</div>
            <div class="value flex-row">
              <div class="num">{{ useEletric }}</div>
              <div class="unit">KWH</div>
            </div>
          </div>
          <div class="content-item" @click="chartClick('100203')">
            <div class="title">上月用水量</div>
            <div class="value">
              <div class="value flex-row">
                <div class="num">{{ useWater }}</div>
                <div class="unit">吨</div>
              </div>
            </div>
          </div>
        </div>
      </screen-box>
      <screen-box title="当日用电量" height="40%">
        <TodayUsePower> </TodayUsePower>
      </screen-box>
      <screen-box title="本月用电量" height="40%">
        <TodayUseWater> </TodayUseWater>
      </screen-box>
    </screen-panel>

    <screen-panel :isExpand="isOpen" position="right" class="panel">
      <screen-box title="不同库区能耗趋势统计" height="34%">
        <DiffStoragePower style="margin-top: 10px"></DiffStoragePower>
      </screen-box>
      <screen-box title="前六月水电量趋势" height="66%">
        <!-- 用电趋势 -->
        <MonthUsePower style="margin-top: 10px; height: 50%"> </MonthUsePower>
        <!-- 用水趋势 -->
        <MonthUseWater title="用水趋势" style="height: 50%"> </MonthUseWater>
      </screen-box>
      <!-- <screen-box title="本月用水趋势" height="33.3%">
        <MonthUseWater> </MonthUseWater>
      </screen-box> -->
    </screen-panel>
  </div>
</template>

<script>
import screenPanel from "../components/ScreenPanel.vue";
import ScreenBox from "../components/ScreenBox.vue";
import TodayUsePower from "../components/TodayUsePower";
import TodayUseWater from "../components/TodayUseWater";
import MonthUsePower from "../components/MonthUsePower";
import MonthUseWater from "../components/MonthUseWater";
// import TrafficChart from "../components/TrafficChart";
import DiffStoragePower from "../components/DiffStoragePower";
import API from "../api/index";
import cacheKeys from "@/common/config/cacheKeys";
export default {
  data() {
    return {
      personTypeData: {},
      isOpen: false,
      useEletric: 0,
      useWater: 0,
    };
  },

  components: {
    screenPanel,
    ScreenBox,
    TodayUsePower,
    TodayUseWater,
    MonthUsePower,
    MonthUseWater,
    DiffStoragePower,
  },

  beforeDestroy() {
    this.$map.hideMap2D();
  },
  mounted() {
    this.$map.showMap2D();
    this.isOpen = true;
    this.queryEnergy();
    this.queryWater();
    this.personTypeData = {
      workNum: 3258,
      visitorNum: 175,
      safeNum: 247,
      cleanNum: 149,
    };
  },

  methods: {
    addMenuFromLeftNav(menu) {
      let tabList = this.$store.getters.menuTabsList || [];
      if (!this.isExist(tabList, menu)) {
        tabList.push(menu);
        if (tabList.length > 10) {
          tabList.splice(0, 1);
        }
        this.$store.commit(cacheKeys.MENU_TABS_LIST, tabList);
      }
    },
    isExist(tabList, menu) {
      for (let i = 0; i < tabList.length; i++) {
        if (tabList[i].code === menu.code || tabList[i].path === menu.path) return true;
      }
      return false;
    },
    chartClick(menuCode) {
      let menu = {}
      this.$fetch(API.checkMenuPath, {
        "menuCode": menuCode
      }).then((res) => {
        if (res.success) {
          if (res.returnObj != null) {
            menu = {
              code: res.returnObj.menuCode,
              name: res.returnObj.menuName,
              path: res.returnObj.path,
              activePath: res.returnObj.path
            }
            this.addMenuFromLeftNav(menu)
            this.$router.push(menu.path)
          } else {
            this.$message.warning("无此功能权限，请联系管理员");
          }
        }
      });
    },
    queryEnergy() {
      this.$fetch(API.energy.queryEnergyRecordByLastMonth, {}).then((res) => {
        if (res.success) {
          this.useEletric = Number(res.returnObj).toFixed(2);
        }
      });
    },
    queryWater() {
      this.$fetch(API.energy.queryWaterRecordByLastMonth, {}).then((res) => {
        if (res.success) {
          this.useWater = Number(res.returnObj).toFixed(2);
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.panel {
  height: 100%;
}
.box-content {
  margin: 22px 0;
}
.content-item {
  // width: 50%;
  height: 100%;
  margin: auto;
  color: #fff;
  cursor: pointer;
  .title {
    font-size: 16px;
    line-height: 26px;
    margin-bottom: 12px;
    width: 134px;
    padding-left: 18px;
    background: url("~@src/common/assets/images/screen/文字背景.png") left bottom no-repeat;
    font-weight: bold;
  }
  .num {
    font-size: 28px;
    line-height: 28px;
    font-family: D-DIN-Bold, D-DIN;
    font-weight: 700;
    margin-right: 4px;
  }
  .unit {
    line-height: 40px;
  }
}

.content-item:hover {
  color: #409EFF;
}
</style>
